import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon';
import { TooltipEl } from 'common/components/tooltip';
export function template() {
  const {
    iconSize
  } = this.helpers.getIconProperties();
  return jsx("div", {
    sel: '.container'
  }, jsx(SvgIconEl, {
    attrs: {
      elref: "orgImg",
      align: "middle",
      icon: "mixpanel-logo"
    },
    style: {
      height: "".concat(iconSize, "px"),
      width: "".concat(iconSize, "px")
    }
  }), this.helpers.isTooltipEnabled() ? jsx(TooltipEl, {
    attrs: {
      placement: this.attr("tooltip-placement")
    }
  }, this.attr("tooltip-text")) : null);
}